import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { HTTPRequestHeaders } from './request_headers';
export var HTTPRequest =
/*#__PURE__*/
function () {
  function HTTPRequest(url, params) {
    _classCallCheck(this, HTTPRequest);

    this.url = url;
    this.method = (params === null || params === void 0 ? void 0 : params.method) || 'GET';
    this.headers = new HTTPRequestHeaders(params === null || params === void 0 ? void 0 : params.headers);
    this.options = (params === null || params === void 0 ? void 0 : params.options) || {};
    this.payload = params === null || params === void 0 ? void 0 : params.payload;
    this.urlExpanded = (params === null || params === void 0 ? void 0 : params.urlExpanded) || false;
    this.retryOptions = (params === null || params === void 0 ? void 0 : params.retryOptions) || {};
  }

  _createClass(HTTPRequest, null, [{
    key: "create",
    value: function create(url, params) {
      return new HTTPRequest(url, params);
    }
  }]);

  return HTTPRequest;
}();